import View from './view';
import {reduxForm} from 'redux-form';
import {Forms} from '../../../../../shared/models/forms';
import {Props} from './model';

const Form = reduxForm<any, Props>({
  form: Forms.applicationsFilterForm,
  destroyOnUnmount: false,
})(View);

export const ProfileApplicationsFilterMobile = Form;
